import { supabase } from './api';

// Current Level Counts – View: courselessoncurrentlevelcount
export async function getLessonCurrentLevelCounts(studentId) {
  const { data, error } = await supabase
    .from('courselessoncurrentlevelcount')
    .select()
    .eq('studentId', studentId)
    .order('level', { ascending: true });

  if (error) throw new Error('Failed to fetch current level counts');
  return data;
}

// Current Level Counts – View: courselessonfuturelevelcount
export async function getLessonFutureLevelCounts(studentId) {
  const { data, error } = await supabase
    .from('courselessonfuturelevelcount')
    .select()
    .eq('studentId', studentId);

  if (error) throw new Error('Failed to fetch current level counts');
  return data;
}

// // Future Grades – Table: courselessonfuturegrade
// export async function getFutureGrades(studentId) {
//   const { data, error } = await supabase
//     .from('courselessonfuturegrade')
//     .select()
//     .eq('studentId', studentId);

//   if (error) throw new Error('Failed to fetch future grades');
//   return data;
// }

// export async function saveFutureGrades(studentId, futureMap) {
//   // Sil ve yeniden ekle
//   const deleteRes = await supabase
//     .from('courselessonfuturegrade')
//     .delete()
//     .eq('studentId', studentId);

//   if (deleteRes.error) throw new Error('Failed to clear future grades');

//   const insertData = Object.entries(futureMap).map(([level, target]) => ({
//     studentId,
//     level,
//     target: parseFloat(target || 0)
//   }));

//   const { error } = await supabase
//     .from('courselessonfuturegrade')
//     .insert(insertData);

//   if (error) throw new Error('Failed to save future grades');
// }

// Overview – Table: courselessonsdesc
export async function getOverviewTexts(studentId) {
  console.log("Getting overview for student:", studentId);
  const { data, error } = await supabase
    .from('courselessondesc')
    .select()
    .eq('studentId', studentId);

  if (error) {
    console.error("Supabase error:", error);
    throw new Error('Failed to fetch overview data');
  }

  return data;
}


export async function saveOverviewTexts(studentId, overviewMap) {
  for (const [type, desc] of Object.entries(overviewMap)) {
    // Sadece bu type'ı sil
    const deleteRes = await supabase
      .from('courselessondesc')
      .delete()
      .eq('studentId', studentId)
      .eq('type', type);

    if (deleteRes.error) {
      console.error(`Error deleting overview for ${type}:`, deleteRes.error.message);
      throw new Error('Failed to delete previous overview data');
    }

    // Yeni overview satırını ekle
    const { error } = await supabase
      .from('courselessondesc')
      .insert([{ studentId, type, desc }]);

    if (error) {
      console.error(`Error inserting overview for ${type}:`, error.message);
      throw new Error('Failed to insert new overview data');
    }
  }
}

// Average GPA (%) verilerini alan fonksiyon
export async function getGpaPercentAverages(studentId) {
  const { data, error } = await supabase
    .from("courselessoncurrentlevelaverage")
    .select("level, average")
    .eq("studentId", studentId);

  if (error) {
    console.error("GPA average fetch error:", error.message);
    throw new Error("Failed to fetch GPA averages");
  }

  return data;
}

// Future Average GPA (%) verilerini alan fonksiyon
export async function getLessonFutureLevelAverage(studentId) {
  const { data, error } = await supabase
    .from("courselessonfuturelevelaverage")
    .select("level, average")
    .eq("studentId", studentId);

  if (error) {
    console.error("GPA average fetch error:", error.message);
    throw new Error("Failed to fetch GPA averages");
  }

  return data;
}

export async function getCalculatedGpaAverages(studentId) {
  const { data, error } = await supabase
    .from("courselessoncurrentlevelaverage")
    .select("level, average")
    .eq("studentId", studentId);

  if (error) {
    console.error("Calculated GPA fetch error:", error.message);
    throw new Error("Failed to fetch GPA for 4.0 scale");
  }

  return data;
}

export async function getApScores(studentId) {
  const { data, error } = await supabase
    .from("courselessonapscore")
    .select("apscore, count")
    .eq("studentId", studentId);

  if (error) {
    console.error("AP score fetch error:", error.message);
    throw new Error("Failed to fetch AP scores");
  }

  return data;
}

